import { ContractorsContainer } from './ContractorsContainer';

const name = 'ContractorsContainer';

export { ContractorsContainer, name };
